import FlowerTitle from "../components/ui/FlowerTitle";
import Button from "../components/ui/Button";
import { useState } from "react";

import { Pagination , Navigation, Autoplay} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import "swiper/scss/pagination";
import "swiper/scss/navigation";
import "swiper/scss/autoplay";
import Modal from "../components/ui/Modal";

const Story = () => {

  const [page, setPage] = useState("story")
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="page-container">
      <nav className="page-nav">
        <Button text="Histoire" color="green" onClick={()=>setPage("story")}/>
        <Button text="Glossaire" color="blue" onClick={()=>setPage("glossary")}/>
      </nav>
      {
        page === "story" ? <StoryPage/> : <Glossary/>
      }
      <nav className="page-nav">
        <Button text="Histoire" color="green" onClick={()=>{
          setPage("story")
          scrollToTop()
        }}/>
        <Button text="Glossaire" color="blue" onClick={()=>{
          setPage("glossary")
          scrollToTop()
        }}/>
      </nav>
    </div>
  )
}

const StoryPage = () => (
  <>
    <FlowerTitle text="Résumé"/>
    <div className="story-wrapper">
      <p className="white-text">
      Le Sous-monde d'Hinomoto
      </p> 
      <p className="white-text">
        Hinomoto est constitué d'une myriade de Sous-mondes différents. <br/>
        Les sources thermales sont le refuge des esprits vengeurs, le Sous-monde des Sardines se trouve au sein du Gigaspace Anshoix, et les séduisantes marées du Shicroaku sont en réalité formées d'innombrables démons qui se mouvoient ensemble comme des algues...
      </p>
      <p className="white-text">
        Au sein de ces différents Sous-mondes vastes et variés, habitaient autrefois de nombreux résidents qui adhéraient au code du Bushido, celui-là même qui allait à l'encontre de leur nature démoniaque.
      </p>
      <p className="white-text">
        Mais tout ceci n'est maintenant plus que de l'histoire ancienne.<br/>
        L'arrivée du Grand Amiral Expandor et de son armée sur ces terres changea à jamais le Sous-monde d'Hinomoto.
      </p>
      <p className="white-text">
        Désormais, les démons d'Hinomoto vivent sous le joug du code de Destruction mis en place par l’Amiral Expandor...
      </p>

      <div className="decree-container">        
        <p className='code-of-destruction'>Code de Destruction d'Hinomoto</p>

        <p className='decree'>
          Décret #1 - Le Bushido : À RÉDUIRE EN POUSSIÈRE !<br/>
          Décret #2 - Quelqu'un d'insatisfait par les taxes ou les salaires ? MASSACREZ-LE.<br/>
          Décret #3 - Amour et amitié : MEME PAS EN RÊVE.<br/>
          Décret #4 - Favoriser les forts et ecraser les faibles ? OH QUE OUI ! <br/>
          Décret #5 - Combattre est ce qui fait tourner le Sous-monde. TEL EST TON CREDO !
        </p>

        <p className='decree'>
        Tous ceux qui désobéissent à ces lois devront se faire HARAKIRI.
        </p>
      </div>
      <p className="white-text">
        Aujourd'hui, les nobles terres des guerriers ne sont rien de plus qu'un lointain souvenir.
      </p>
      <p className="white-text">  
        Notre conte prend place dans ces mondes qui ont été dérobés de leur honneur.<br/>
        C'est l'histoire d'une fille passionnée par le code du bushido…. Et d'un homme qui l'excècre.<br/>
        Ces deux devront cependant joindre leurs forces pour défendre leur conviction...
      </p>
    </div>
  </>
)

const Glossary = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    size: 8
  })

  return (
<>
      <Modal modal={modal} setModal={setModal} url="glossary_ss_0.jpg"/>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Petit lexique de Hinomoto
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <div className="slide-wrapper">
            <Swiper
              slidesPerView={1}
              autoplay={true}
              pagination={true}
              loop={true}
              modules={[ Pagination, Navigation, Autoplay ]}
              className="mySwiper"
            >
              <SwiperSlide>
                <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_01.jpg`} alt="" className="ss" 
                  onClick={()=>{
                    setModal(
                      {
                        ...modal,
                        'visible': true,
                        'current': 1,
                      }
                    )
                  }}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_02.jpg`} alt="" className="ss"
                  onClick={()=>{
                    setModal(
                      {
                        ...modal,
                        'visible': true,
                        'current': 2,
                      }
                    )
                  }}
                />
              </SwiperSlide>
              <SwiperSlide>
                <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_03.jpg`} alt="" className="ss"
                  onClick={()=>{
                    setModal(
                      {
                        ...modal,
                        'visible': true,
                        'current': 3,
                      }
                    )
                  }}
                />
              </SwiperSlide>
            </Swiper>
            </div>
          </div>
          <div className="item">
            <p className="white-text item-text">
              Hinomoto... Une province composée de nombreux Sous-Mondes et caractérisée par une vision toute particulière du « Bushido », la Voie du Guerrier.
              Le Grand Amiral Expandor n'hésite cependant pas à l'envahir et bafouer la fierté de tous les bushis la peuplant...
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Le Sous-Monde d'Edow
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_01.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 1,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_02.jpg`} alt="" className="ss"
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
              }}
            />
          </div>
        </div>
        <p className="white-text item-text pair-text">
          Centre névralgique de la province de Hinomoto, avec en son centre le château d'Edow.
          À ses pieds se trouvent la basse ville et son quartier pauvre.
        </p>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Le Sous-Monde de La Tombe (Seine-et-Morne)
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_04.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 4,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              Un Sous-Monde aux paysages urbains hauts en couleur, fortement influencé par l'ouverture de la culture de la province sur l'extérieur.
              La rumeur dit que le shogun Oyéyasu y aurait bâti une villa secondaire dans laquelle il organiserait des banquets pour le moins festifs tous les jours...
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Le Sous-Monde des Sardines
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_02.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              Un Sous-Monde situé à l'intérieur du Gigaspace Anshoix.<br/>
              Numéro un dans l'industrie de la pêche. Son port qui grouillait autrefois de pêcheurs, gît aujourd'hui en ruine sous le coup des lourdes taxes imposées par le Magistrat de l'Océan, Sea Again.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Le Sous-Monde de Pairimpair
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_05.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 5,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              La terre sacrée de tous les joueurs de jeux d'argent et de hasard, fondée sous les ordres du Showgunat.
              C'est un endroit animé, dans lequel tous les démons aspirant à devenir riches sans fatigue en jouant leur fortune au casino se retrouvent.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Les sources thermales des Gueulis
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_06.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 6,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              L'une des trois plus grandes sources thermales de toute la province de Hinomoto.<br/>
              Elle est réputée pour ses esprits hantés dont la haine vont jusqu’à faire bouillir la source. Ses eaux scintillantes peuvent même ressusciter les morts.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Les Sept Armes fondatrices
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_07.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 7,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text pair-text">
              Des armes légendaires possédant chacune une âme. Elles sont toutes dispersées sur le territoire de la province de Hinomoto.<br/>
              La rumeur dit que seuls les guerriers capables de faire résonner leur âme avec ces armes peuvent être reconnus comme leurs vrais possesseurs. L'arme en main, ils acquièrent alors une puissance capable de terrasser même les dieux.
            </p>
          </div>
        </div>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text">
          Le code de Destruction de Hinomoto
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <p className="white-text item-text pair-text">
          Loi instaurée par le Showgunat après l'invasion du Grand Amiral Expandor sur le territoire de Hinomoto.<br/>
          Elle renie les valeurs du Bushido et oblige ceux qui ne la respectent pas à se faire hara-kiri. C'est à cause d'elle que tous les bushis de la province se voient obligés de renoncer à leur honneur de guerriers.
        </p>
      </section>
      <section className="pair-wrapper">
        <h1 className="pair-title white-text" style={{marginTop: '25px'}}>
          Les Treize Magistrats
        </h1>
        <div className="underline">
          <div className="bar"></div>
        </div>
        <div className="pair">
          <div className="item">
            <img src={`${process.env.PUBLIC_URL}/img/ss/glossary_ss_08.jpg`} alt="" className="ss" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 8,
                  }
                )
              }}
            />
          </div>
          <div className="item">
            <p className="white-text item-text">
              Subalternes du Grand Amiral Expandor, le secondant pour éradiquer le Bushido de toute la province de Hinomoto.
              Ils sont composés entre autres du Magistrat de la Défense Gros Bill, de celui de l'Océan, Sea Again, ainsi que de Suisen, le Magistrat de la Prémonition, capable de lire dans l'avenir.
              Des ennemis dont il est impossible d'ignorer l'existence pour tous les braves souhaitant renverser le Showgunat et sauver Hinomoto.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}

export default Story;